import Api from 'api';
import './_styles.scss';
import * as yup from "yup";
import Login from './_Login';
import Signup from './_Signup';
import { Error } from 'components';
import AppLogo from "assets/app-logo.svg";
import Cookies from 'universal-cookie';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';

export default class index extends Component {

  constructor(props) {

    super(props);

    this.api = new Api();

    this.cookies = new Cookies();

    this.state = {

      loading: false,

      name: '',
      password: '',
      email_address: '',
      confirm_password: '',

      errors: {},
      remember: false,
      login_error: null,
      login_view: true,

    }

  }

  componentDidMount = () => {

    const session = this.cookies.get('session_data');

    const authenticated = (!!session.uid && session.logged_out!==true);

    return (!authenticated) ? this.set_page_view() : this.profile(session);

  }

  profile = ({uid}) => window.open(`/account/profile/${uid}`, '_self');

  set_page_view = () => {
    if (!this.props.signup) return;
    return this.setState({ login_view: false });
  }

  onChangeEvent = (e) => {

    const { errors } = this.state;

    const { type, name, value, checked } = e.target;

    const new_errors = { ...errors, [name] : null };

    const new_value = (type === 'checkbox') ? checked : value;

    return this.setState({ [name]: new_value, errors: new_errors });

  }

  onError = (err) => this.setState({ errors: err,loading: false });

  validate_data = async (data = {}) => await yup.object().shape({

    name: yup.string().required('Enter your Name'),

    email_address: yup.string()
      .email("Invalid Email Address")
      .required("Email Address is required!"),

    password: yup.string()
      .required('Enter Valid Password')
      .min(8, 'Password is too short - should be 8 chars minimum.')
      .matches(/[a-zA-Z]/, 'Password can only contain Latin letters.'),

    confirm_password: yup.string()
      .oneOf([yup.ref('password'), null], 'Passwords must match')

  }).validate(data, { abortEarly: false }).catch(({ inner = [] }) => ({

      // eslint-disable-next-line
      error_messages: inner.reduce((a, i) => (a[i.path] = i.message, a), {})

  }));

  authenticate = async ({ login_view } = this.state) => {

    if (!login_view) return await this.api.signup(this.state);

    return await this.api.authenticate(this.state);

  }

  payload = () => {

    const { name,email_address,password,confirm_password,login_view } = this.state;

    if (!login_view) return { name, email_address, password, confirm_password };

    return { email_address, password, name: 's', confirm_password: password };

  }

  validate_form = async () => {

    if (!!this.state.loading) return;

    if (!this.state.loading) this.loading(true);

    const { error_messages } = await this.validate_data(this.payload());

    if (!!error_messages) return this.onError(error_messages);

    const { error, id, name }  = await this.authenticate();

    if (!!error) this.setState({ login_error: error });

    return this.redirect(error, id, name);

  }

  redirect = async (error, uid, name, email=this.state.email_address) => {

    if (!!error) return this.loading(false);

    const conversion = !this.state.login_view;

    const session = this.cookies.get('session_data');

    const user_data = { ...session, uid, email, name, conversion };

    this.cookies.set('session_data', user_data, { path: '/' });

    await this.api.update_session(user_data);

    return this.props.history.goBack();

  }

  toggleView = () => {

    const { login_view } = this.state;

    return this.setState({ login_view: !login_view });

  }

  loading = (value,force) => {

    const { loading } = this.state;

    if (!force && value===loading) return;

    return this.setState({ loading: value });

  }

  render() {
    return (
      <section className='Section-Login'>
        <div className="Login-Wrapper">

          <Link
            to='home'
            className="Logo"
            style={{ backgroundImage: `url(${AppLogo})` }}
          />

          <Login
            state={this.state}
            toggleView={this.toggleView}
            onValidate={this.validate_form}
            visible={!!this.state.login_view}
            onChangeEvent={this.onChangeEvent}
          />

          <Signup
            state={this.state}
            toggleView={this.toggleView}
            onValidate={this.validate_form}
            visible={!this.state.login_view}
            onChangeEvent={this.onChangeEvent}
          />

          <div className="copy">
            Copyright 2019, Adenzo Comfies
          </div>

          <Error
            duration={5000}
            visible={this.state.login_error}
            message={this.state.login_error}
            callback={()=>this.setState({ login_error: null })}
          />

        </div>
      </section>
    )
  }
}
